import { useSignupState } from './useSignupState'

export const useAuthProvider = () => useSignupState().authProvider
